import { render, staticRenderFns } from "./root.vue?vue&type=template&id=68229162&"
import script from "./root.vue?vue&type=script&lang=js&"
export * from "./root.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports